<template>
  <highcharts class="chart" :options="chartOptions" />
</template>

<script>
import HighchartsMethods from '@/components/mixins/highcharts-methods';
import DateMethods from '@/components/mixins/date-methods';

const ENVIRONMENTAL_CHART_OPTIONS = {
  xAxis: {
    title: { text: '<b>Time<b>' },
    type: 'datetime'
  },
  yAxis: [
    {
      title: { text: 'Temperature [\u2103]' },
      gridLineWidth: 0.5,
      showEmpty: false
    },
    {
      title: { text: 'Humidity [%]' },
      gridLineWidth: 0.5,
      showEmpty: false,
      opposite: true
    }
  ]
};

export default {
  name: 'EnvironmentalChart',
  mixins: [HighchartsMethods, DateMethods],
  props: {
    activeTimeView: { type: Number, required: true },
    chartData: { required: true },
    date: { type: String, required: true }
  },
  computed: {
    chartOptions() {
      const series = this.chartData;
      const { startDate, endDate } = this.selectTimespan(this.activeTimeView, this.date);
      const xAxis = this.createXAxis({ startDate, endDate, span: this.activeTimeView });

      return this.generateChart({ ...ENVIRONMENTAL_CHART_OPTIONS, xAxis, series });
    }
  }
};
</script>
